<template>
  <div class="container">
    <div class="row">
      <div class="col-1">
        <!-- space -->
      </div>
      <div class="col-10 mt-5 text-center text-white">
        <img src="assets/myWayParking.png" alt="" height="120">
        <br>
        <br>
        <form>
          <div class="form-group">
            <label class="text-color-custom font-weight-bold">EMAIL</label>
            <input type="email" class="form-control outline-custom text-center text-white" placeholder="Enter email">
          </div>
          <div class="form-group">
            <label class="text-color-custom font-weight-bold">VEHICLE REGISTRATION</label>
            <input class="form-control outline-custom text-center text-white" placeholder="Enter vehicle registration">
          </div>
          <div class="form-group">
            <label class="text-color-custom font-weight-bold">PASSWORD</label>
            <input type="password" class="form-control outline-custom text-center text-white" placeholder="Password">
          </div>
          <div class="row">
            <div class="col text-right">
              <router-link to="/passengersConfirmation" class="btn btn-custom font-weight-bold" tag="button">SIGN IN</router-link>
              <br>
              <p class="text-small-font">NEW USER?
                <router-link to="" tag="a">REGISTER</router-link>
              </p>
            </div>
          </div>
        </form>
      </div>
      <div class="col-1">
        <!-- space -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLogin'
}
</script>

<style>
  button.btn.btn-custom{
    color: #fff;
    background-color: #00a8e5;
    border-color: #00a8e5;
    border-radius: 25px;
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  button.btn.btn-custom:hover{
    color: #fff;
    background-color: #1ac2ff;
    border-color: #1ac2ff;
  }
  input.form-control.outline-custom{
    border-radius: 25px;
    background-color: rgba(255,255,255,0.6);
  }
  .text-color-custom{
    color: #00a8e5;
  }
  .text-small-font {
    font-size: 0.7em;
    line-height: 1.8em;;
    padding-right: 0.5rem !important;
  }
</style>
